export default {
  form: {
    validation: {
      required: "This field is required",
      min: "Must be at least {num}",
      max: "Must not be over {num}",
      minCharacters: "Must be at least {num} characters",
      maxCharacters: "Must not be more than {num} characters",
      minDigits: "Must be at least {num} digits",
      maxDigits: "Must not be more than {num} digits",
      tooShort: "Entry is too short",
      tooLong: "Entry is too long",
      invalidNumber: "Invalid Number",
      charLengthRuleForTextArea: "Require a min of 75 and max 10000 characters",
      spacesNotAllowed: 'Spaces not allowed',
      numbersNotAllowed: 'Numbers not allowed',
      specialCharacters: 'Special Characters not allowed',
      pattern: 'The format of the value is incorrect'
    },
    file: {
      select: "Select a file",
      selectPhoto: "Select a photo",
    },
    typeSearch: "Type to search"
  },
  actions: {
    "cancel": "Cancel",
    "close": "Close",
    "copy" :"Copy",
    "login": "Sign In",
    "createAccount": "Create Account",
    "learnMore": "Learn about Jeenie",
    "ok": "Ok",
    "getAnotherInterpreter": "Get Another Interpreter",
    "finishInterpretingService": "Finish Interpreting Service",
    "rateJeenie": "Rate Jeenie",
    "skipForNow": "Skip for Now",
    "submit": "Submit",
    "back": "Back",
    "joinCall": "Join Call",
    "skip": "Skip",
    "endCall": "End Interpreting",
    "report": "Report",
    "retry": "Retry",
    choose: "Choose",
    continue: "Continue",
    goBack: "Go back",
    saveChanges: "Save Changes",
    gobackBtn: 'No, go back',
    rescheduleCallBtn: 'Yes, I want to reschedule the call',
    copiedToClipboard: 'Info copied to clipboard',
    connect: 'Connect',
    next: "Next",
  },
  loginForm: {
    "signin": "Sign in",
    "email": "Email",
    "password": "Password"
  },
  loginErrors: {
    "noEmail": "Email not found",
    "wrongPassword": "Incorrect Password",
    "linguistNotAllowed": "Linguist profile not allowed on Zoom App",
    "default": "Unknown error",
    "linguistRestriction": "Linguist profiles are not allowed to use the Jeenie for Zoom App. Please use web or mobile app."
  },
  menu:{
    logout: "Logout"
  },
  logout:{
    confirm: "Are you sure you want to logout?"
  },
  auth: {
    loginError: "There was a problem logging in",
    logoutError: "There was an error logging out",
    deviceError: "There was an error authenticating",
    defaultError: "Your credentials have expired or are invalid.",
    noUserError: "No user found for that email address",
    noEmailError: "Email not found",
    passwordIncorrectError: "The password was incorrect",
    authRequiredError: "You must log in again",
    registrationError: "There was an unexpected issue creating your account.",
    userExistsError: "This email address has already been registered. Did you forget your password?"
  },
  history: {
    subheader: "History",
    recentCalls: "Recent Calls",
    noData: "Your call history is empty at the moment.",
    seeMore: "See More",
    table: {
      headers: {
        createdAt: "When",
        endedAt: "When",
        createdBy: "Customer",
        language: "Language",
        duration: "Duration",
        linguist: "Linguist",
        user: "User",
        userToTakeCall: "User to Take Call",
        dateAndDuration: "Date & Duration",
        action: "Action",
        dateAndTime: "Date & Time",
      },
      filters: {
        createdBy: {
          all: "Select All",
          selected: "{num} selected",
          placeholder: "By user..."
        },
        daterange: {
          placeholder: "Search date range"
        }
      }
    },
    mainScreen:{
      noConnection: 'No Connection',
      processing: 'Processing',
      callCancelled: 'Call Canceled',
      partnerInterpreter: 'Partner Interpreter',
      moreDetails: 'More Details',
      reportIssue: 'Report Issue',
      report: 'Report',
      actionRequired: 'Action Required',
      success: 'Thanks for letting us know!',
      minute270ValidationMessage:'value must be between 1 to 270 minutes',
      callDetail: {
        label: 'Call Details',
        languages: 'Languages',
        addRating: 'Add Rating',
        cancelPolicyLabel: 'Cancellation Policy',
        cancelPolicy: 'This call was canceled. Please note: Your linguists will be paid for reserved time.',
        cancelPolicySecond: 'Session billed: The request to change or cancel scheduled call was within 24 hours of session.',
        dateAndDuration: "Date And Duration",
        addDuration: 'Add Duration',
        callType: 'Type Of Call',
        scenario: 'Scenario',
        callPlatform: 'Call Platform',
        scheduled: 'Scheduled',
        immediateVirtual: 'On-Demand',
        notRated: 'Not Rated',
        noRating: 'No Rating',
        ratings: 'Ratings',
        addDurationDialog: {
          label: 'Add Duration',
          longCall : 'How long was the Call?',
          addCallTime : 'Add Call Time',
          thanks: 'Thanks for submitting your call time!',
        }
      },
      reportIssueDialog: {
        label: 'Report Issue',
        issueExperience: 'What issue did you experience?',
        technicalDifficulty: 'Technical difficulty',
        lateForCall : 'Client late to the call',
        lateForCallCustomer : 'Interpreter late to the call',
        incorrectDuration : 'Call duration is incorrect',
        callShowProcessing : 'Call shows as “Processing”',
        abuse : 'Obscene or aggressive behavior',
        other : 'Other'  
      },
      reportAbuseDialog: {
        label: 'Report Abuse',
        reportingBehavior: 'You are reporting behavior that you believe \n is inappropriate and harms the Jeenie community.',
        accountSuspension: 'Doing so may result in the suspension or removal \n is of their account. Do you want to proceed?',
        props: {
          title: 'Abuse',
          textLabel: 'Let us know what happened.',
          textAreaPlaceHolder: 'Please share specifics about the inappropriate behavior you witnessed',
        }
      },
      reportOtherDialog: {
        propsDefaultValues: {
          title: 'Issue',
          textLabel: 'Let us know what happened.',
          textAreaPlaceHolder: 'Tell us more about this call...',
        }
      },
      reportCallShowAsProcessingDialog: {
        label: 'Report Abuse',
        working: 'We’re working on it. ',
        longerToProcess: "Occasionally a Jeenie session will take longer to process. Our system identifies unresolved \n call times and our team works to resolve the issue.",
        finalizedPayments: 'All call times will be finalized before payments and billing at the end of the month.',
        letUsKnow: 'Still want to let us know that this call has been processing for a while?',
        btnText: 'Notify Jeenie',
      },
      reportIncorrectDurationDialog: {
        line: 'How long was the call ?',
        textAreaPlaceHolder: 'Tell us more about this call...',
      },
      reportLateForCallDialog: {
        interpreterText: 'Did the interpreter join the call?',
        clientText: 'Did the client join the call?',
        line: 'How many minutes were they late?',
        textPlaceHolder: 'Enter time in minutes',
        sorry: "We're sorry they weren't able to join the call on time. We'll be looking into your session.",
        minuteValidationMessage:'value must be between 1 to 60 minutes',
      },
      reportTechIssuesDialog: {
        technicalDifficulty: "What's the technical difficulty?",
        canTell: "Anything else you can tell about this call?",
        textPlaceHolder: 'More details helps us to understand and fix issues',
        issues:{
          noAudio:"No Audio",
          noVideo:"No Video",
          poorAudio:"Poor Audio",
          poorVideo:"Poor Video",
          callDropped:"Call Dropped",
          lags:"Lots of Lag",
          other:"Other"
        }
      },
    },
    download: {
      title: 'Call History Download',
      subtitle: 'The current filter settings will export {num} {rowVsRows} to a CSV file.',
      dateRange: 'Date Range:',
      userFilter: 'User Filter:',
      footer: 'You can adjust your export using the filtering options on the Call History page.',
      confirm: 'Confirm',
      notApplied: 'Not applied',
      rowSingular: 'row',
      rowPlural: 'rows',
    }
  },

  zoom:{
      startMeeting: "Start Interpretation",
      startMeetingDisabled: "The ability to start an on-demand Zoom meeting where you can request a Jeenie interpreter requires a paid Zoom license",
      requestChanges: "Yes. Update My Settings.",
      restrictionMessages: {
        notLicensedZoomUser: 'The ability to start an on-demand Zoom meeting where you can request a Jeenie interpreter requires a paid Zoom license',
        notScheduled: `To request an on-demand Jeenie interpreter, please end this meeting. Then start a new one using the "Start New Interpreter Meeting" button within the Jeenie for Zoom App.`,
        wrongSettings: 'The current Zoom meeting settings prevent an on-demand Jeenie interpreter from joining. If you want to change the settings to allow a Jeenie into THIS meeting, click below.',
        customerRestricted: 'The Jeenie for Zoom app is currently unavailable. Jeenie for Zoom will be available starting February 19th.',
        notHostOrCoHost: 'You must be the meeting host, or co-host, in order to request a Jeenie interpreter.'
      },
      restricedUser: {
        notLicensedZoomUser: "On-demand Jeenie interpreters are only available to Licensed Zoom users.",
        notEnterpriseJeenieUser: "Scheduling a Jeenie interpreter in advance requires an Enterprise Jeenie account."
      },
      meetingUnassociated:{
        disclaimer: "This Zoom meeting is not associated with a Jeenie interpreting session.  You may close the Jeenie for Zoom app.",
        instruction: "If you are expecting to receive on-demand interpreting requests, please leave this Zoom meeting and return to the Jeenie web or mobile app."
      },
      sessionAlreadyEnded: "Your session has been ended.  You should leave the Zoom meeting and return to the Jeenie app to take future calls.  You will not be paid for more time in this session."
    },
  session: {
    create: {
      header: "Interpreters are standing by...",
      error: {
        header: "Something went wrong",
        reLogin: "You need to login again",
        reInstall: "You need to re-install the application",
        noMeeting: "Only the Zoom meeting owner may invite an interpreter into the Zoom meeting.",
        noPaymentMethod: "You must add a payment method to your Jeenie account before you can request an interpreter.  Please sign in to your Jeenie account on the web in order to manage your payment method.",
        default: "We encountered an unexpected error while requesting your interpreter.",
      },
      primaryLang: {
        label: "I speak",
        placeholder: "Select your language"
      },
      secondaryLang: {
        label: "Get an interpreter for",
        placeholder: "Select an option"
      },
      scenario: {
        label: "Service",
        placeholder: "Select an option"
      },
      buttons: {
        schedule: "Reserve a Future Time",
        cancellation: "Cancellation Policy",      
      },
    },
    finish:{
      header: "End Interpreting Session?",
      remove:{
        title: "Remove Interpreters from Meeting",
        description: "Are you sure you want to end the interpreting session?  Be sure to communicate to your interpreter that you are ready for them to leave the meeting."
      },
      endNow: {
        title: "End Now",
        interpreterLeft: "Your interpreter has left the meeting.",
        description: "This will end the Jeenie interpreting session but does not prevent the interpreter from rejoining the meeting at a later time.",
        tip: {
          header: "PRO TIP:",
          text: " Before your Jeenie linguist disconnects, use the Zoom participant menu to remove them from the Zoom meeting. This will also end the Jeenie session automatically."
        }
      }    
    },
    participant: {
      invite: {
        link: {
          by:"Copy Join Info",
          description: "Invite particpants by link"
        },
      },
    },
    past: {
      title: "History",
      information: "See your complete usage history (on all platforms) in your Jeenie account.",
      viewHistory: "View My History"
    },
    connecting: {
      header: "We are getting a Jeenie now...",
      timeOut: "Session timed out",
      linguistJoining: {
        header: "A linguist is joining the call",
        note: "Once your linguist joins the meeting, please give them a moment to get set up before asking them to begin interpreting."
      }
    },
    inProgress: {
      header: "Your Jeenie interpreter is on the way and will join the call shortly...",
      amountOfJeenies: "{count} Jeenie on call",
      callEndedFromLing: "Your interpreter is not currently in the meeting. If you do not expect them to return, please select “Finish Interpreting” to end the session with your interpreter.",
      callEndedFromLingDueToNetworkIssue: "Linguist got disconnected from the meeting due to a network issue. You can wait for their return or end the call"
    },
    end: {
      callEnded: "Call Ended"
    },
    scheduled: {
      title: "Reserve a Jeenie Interpreter",
      forYou: "Scheduled",
      noUpcoming: "No Upcoming Calls",
      inProgress: "Your interpreter is scheduled to join this call at",
      disclaimer: "This language pair requires at least {duration} advanced notice. If you select a time shorter than this window, we cannot guarantee we can fulfill the request in time but will try our best.",
      success: "All Jeenie terms of use and privacy policies apply. After we have reviewed your request, a member of the Jeenie team will be contacting you with any questions and to confirm the details. Thank you!",
      error: "We were unable to submit your request.  Please reach out to your account representative to schedule a session.",
      requestChangeDescription: "As per Jeenie’s cancellation policy, Jeenie requires 24 hours’ notice for modifying scheduled calls. Since your request is within the 24-hour notice period you may still be charged, or we may not be able to accommodate your request. Please explain the modifications you want to make below.",
      editDetailsDisclaimer: "Most fields here can be updated without affecting scheduling. To edit a field not shown here, please ",
      editDetailsDisclaimerBtn: "reschedule the call.",
      editCallDetails:{
        title: "Edit Call Details",
        leave: {
          confirm: 'Are you sure you want to leave?',
          description: 'You have unsaved changes.',
        },
      },
      primaryLang: {
        label: "I speak (Native Language)"
      },
      scenario: {
        label: "Service",
        placeholder: "Select"
      },
      beginningSoon: {
        description: {
          linguist: 'Join when you are ready. You will connect to the client once they join.',
          customer: 'The interpreter will be invited to the call once you join. Join when you are ready.'
        },
        callHappeningNow:'call is happening now',
        callBeginsSoon:'call begins soon',
      },
      gender:{
        label:"Preferred gender (optional)",
        info:"We cannot guarantee that we will find someone of your requested gender but will do our best."
      },
      genderPreference:{
        label:"Check this box if you want us to cancel if we can’t get your preferred gender"
      },
      fromDate: {
        label: "Start Date",
        placeholder: "Select"
      },
      fromTime: {
        label: "Start Time",
        placeholder: "Select"
      },
      from: {
        label: "Start Date/Time",
        placeholder: "Select time"
      },
      untilDate: {
        label: "End Date",
        placeholder: "Select"
      },
      untilTime: {
        label: "End Time",
        placeholder: "Select"
      },
      topic:{
        label:"Topic",
        placeholder:"Examples: behavioral health, endocrinology, immigration",
        info:"Tell us what will be discussed to give the interpreter more context."
      },
      ccEmails:{
        label:"Other Emails to Notify (optional)",
        info:"These emails will be notified when the call is confirmed.",
        tooltip: 'This is often used by teams who don’t have individual user accounts but rather share one for a given location or department. You can add business emails to be notified even if these emails don’t have their own Jeenie accounts.'
      },
      url:{
        label: "URL to join call",
        info: 'Make sure to use the full meeting link. For example, inputting only "zoom.us" is not valid.',
        placeholder: "https://"
      },
      schedulingFor: {
        label: "Member who will place the call (Optional)",
        info: "Only change this if you are scheduling this call for another member of your organization."
      },
      secondaryLang: {
        label: "Get an interpreter for",
        placeholder: "Select a language"
      },
      modify: {
        modify: "Modify",
        cancel: "Cancel Call",
        cancelRequest: "Request to cancel",
        modifyRequest: "Request to change",
        changeRequestReason: "Reason",
        requestChange:"Request Change",
        reschedule:"Reschedule Call",
        edit:"Edit Call Details",
        changeRequestCancel: "Per Jeenie’s cancellation policy, Jeenie requires 24 hours’ notice for cancelling scheduled calls. Since your request is within the 24-hour notice period you may still be charged.",
        changeRequestModify: "Per Jeenie’s cancellation policy, Jeenie requires 24 hours’ notice for modifying scheduled calls. Since your request is within the 24-hour notice period you may still be charged, or we may not be able to accommondate your request. Please explain the modifications you want to make below.",
        changeRequestSuccess: "We have received your request. A team member will be in touch soon to confirm any details.",
        changeMessagePlaceholder: "Enter details here",
        late: {
          modify: "Late Modify",
          cancel: "Late Cancel"
        },   
        confirmCancellation: "Confirm Cancellation",
        confirmCallDetails: "Confirm Call Details",
      },
      cancel: {
        title: 'Cancel Scheduled Call',
        confirm: 'Are you sure you want to cancel?'
      },
      cancellation: "Please review our Cancellation Policy and other important information.",
      choose: {
        title: "Choose a meeting",
        description: "Please choose a meeting in order to reserve an interpreter",
      },
      validations:{
        scheduleDuration: "A scheduled call must be between 30 minutes and 6 hours in length.",
        advanceNotice: "Your Service Agreement requires more advanced notice to schedule.",
        chooseLanguage: "Please choose a different language."
      },
      disabled: {
        unavailableBefore: "Scheduling is not currently enabled for your account. Please sign into your Jeenie account on the web at ",
        unavailableAfter: " to resolve any outstanding account issues, or to contact support.",
        button: "Manage Payment Details",
      },
      message: {
        label:"Comments (Optional)",
        placeholder: "Please do not include any Personally Identifiable Information (PII) in your comments. Share info about the appointment/event that is helpful for the session or additional instructions for the interpreter, including any client dialect or place of origin details.",
        info:"Please do not place meeting links in this box. Our system will not recognize them."
      },
      cancelLabel:"Cancel this Call",
      cancelConfirm: "Are you sure you want to cancel this call?",
      cancelConfirm24:"Per Jeenie’s cancellation policy, Jeenie requires 24 hours’ notice for modifying scheduled calls. Since your request is within the 24-hour notice period you may still be charged, or we may not be able to accommodate your request. Please explain the modifications you want to make below.",
      confirmCancelCall:"Yes, Cancel this Call",
      syncCallLabel:"Sync Call Information",
    },
    schedule: {
      title: "Reserve a Jeenie Interpreter",
      description: "To schedule an interpreter for an upcoming appointment or event, enter the information below.",
      disclaimer: "For optional availability, please schedule 48 hours advance.",
      labels: {
        primaryLang: "I speak",
        secondaryLang: "I need help with",
        startTime: "Start Date/Time ",
        endTime: "End Date/Time",
        scenario: "I need an interpreter for",
        link: "Zoom Link",
        notes: "Notes",
      },
      placeholders: {
        selectDate: "Select Date",
        selectTime: "Select Time",
        notes: "Please provide any additional information about the appointment/event or special instructions for the interpreter. If you share your Jeenie ID with anyone else, please include your name, phone number and email address, so that we can contact you with a confirmation and /or ...",
      },
      cancellationPolicy: "Cancellation policy and other important information",
    },
    customFieldDialogs: {
      pre: {
        headerText: "On Demand Call",
        formHeading: "Custom fields",
      },
      post: {
        headerText: "Additional Information",
        formHeading: "Custom fields for",
        errorText: "You cant close without submitting all required fields",
      },
    },
  },
  fields: {
    gender: {
      label: "Gender",
      male: "Male",
      female: "Female",
      nonbinary: "Non-Binary",
      nopreference:"No preference",
      other: "Other",
      declined: "Prefer not to specify",
      notset: "Not specified",
      edit: "Gender",
      why: "Why do we ask this?",
      explanation: "Customers may request assistance from someone with a specific gender. If you prefer not to disclose your gender, you will not be matched with customers who express a preference.",
    },
  },
  splitRatings: {
    enjoyJeenie: "Enjoy Jeenie?",
    feedback: "Your feedback means a lot!",
    lowRatingFeedback: {
      headerText: "Oh Snap!",
      ratedLowText: "We see you have given a low rating.",
      helpImproveText: "Help us to improve.",
    }
  },
  partnerInterpreter:{
    title: 'Partner Interpreter'
  },
  metaData: {
    textFieldPlaceholder: "Please enter value",
    dropdownPlaceholder: "Please select value",
    successToast: "Saved Successfully"
  },
  customerRating: {
    rateLinguist: "How did I do as an interpreter?",
    rateCallQuality: "How was the connection quality?",
    whatGoodLinguist: "What did I do well?",
    whatBetterLinguist: "What can I improve?",
    whatGood: "What was good?",
    whatBetter: "What can be better?",
    comments: "Anything else we should know?",
    commentsPlaceholder: "Please add any additional comments here.",
  },
  emailverify: {
    title: "Confirm Email Address",
    instruction: "To receive a new email with a link to verify your email address, please your submit your email address below.",
    submit: "Send Link",
    defaultError: "Error submitting email address",
    fieldLabel: "Email",
    fieldRequired: "Email is required",
    fieldInvalid: "Email must be valid",
    successAlert: "Email sent to {email}",
    successTitle: "An email has been sent to the address you provided.  Please click on the link in the email to verify your email address.",
    successSpam: "If you do not receive the email within the next 5 minutes, check your spam folders, or request another link.",
    successTryAgain: "Request a new link",
  },

  tabsOptions: {
    callDetails: 'Call Details',
    additionalInformation: 'Custom Fields'
  },
  // for use during primary language selection
  languages: {
    headers: {
      "recent":       "Recently Used",
      "available":    "Available Languages",
    },
    "eng":          "English",
    "ase":          "American Sign Language (ASL)",
    "cmn":          "Chinese (Mandarin)",
    "yue":          "Chinese (Cantonese)",
    "tois1237":     "Chinese (Taishanese)", //glottolog - no ISO639-3 code. https://glottolog.org/resource/languoid/id/tois1237
    "zho-cn-shang": "Chinese (Shanghainese)",
    "zho-tw":       "Chinese (Taiwanese)",
    "jpn":          "Japanese",
    "spa":          "Spanish",
    "spa-r-la":     "Spanish (Latin America)",
    "spa-es":       "Spanish (Spain)",
    "deu":          "German",
    "fra":          "French",
    "fra-ca":       "French (Canada)",
    "fra-fr":       "French (France)",
    "arb":          "Arabic (Modern Standard)",
    "aao":          "Arabic (Algerian, Moroccan & Tunisian)",
    "arz":          "Arabic (Egyptian)",
    "ara-arz_apd":  "Arabic (Egyptian or Sudanese)",
    "afb":          "Arabic (Gulf)",
    "apd":          "Arabic (Sudanese)",
    "acm":          "Arabic (Iraqi)",
    "ara-apc_ajp":  "Arabic (Levantine)",
    "azj":          "Azeri (North)",
    "azb":          "Azeri (South)",
    "por":          "Portuguese",
    "por-br":       "Portuguese (Brazil)",
    "por-pt":       "Portuguese (European)",
    "rus":          "Russian",
    "ita":          "Italian",
    "kor":          "Korean",
    "nld":          "Dutch",
    "swe":          "Swedish",
    "nor":          "Norwegian",
    "tur":          "Turkish",
    "pol":          "Polish",
    "dan":          "Danish",
    "fin":          "Finnish",
    "tha":          "Thai",
    "heb":          "Hebrew",
    "ind":          "Indonesian",
    "pes":          "Farsi (Persian)",
    "prs":          "Dari (Persian)",
    "hin":          "Hindi",
    "ces":          "Czech",
    "msa":          "Malay",
    "pus":          "Pashto",
    "sin":          "Sinhala",
    "mah":          "Marshallese",
    "ell":          "Greek",
    "hun":          "Hungarian",
    "ron":          "Romanian",
    "vie":          "Vietnamese",
    "ben":          "Bengali",
    "bib":          "Bissa",
    "cat":          "Catalan",
    "fil":          "Filipino",
    "tam":          "Tamil",
    "slk":          "Slovak",
    "kaz":          "Kazakh",
    "ltz":          "Luxembourgish",
    "kur":          "Kurdish",
    "ukr":          "Ukrainian",
    "afr":          "Afrikaans",
    "hrv":          "Croatian",
    "glg":          "Galician",
    "slv":          "Slovenian",
    "lit":          "Lithuanian",
    "ckb":          "Sorani",
    "jav":          "Javanese",
    "urd":          "Urdu",
    "sqi":          "Albanian",
    "tel":          "Telugu",
    "srp":          "Serbian",
    "yor":          "Yoruba",
    "hau":          "Hausa",
    "bul":          "Bulgarian",
    "uzb":          "Uzbek",
    "swa":          "Swahili",
    "eus":          "Basque",
    "bel":          "Belarusian",
    "tat":          "Tatar",
    "amh":          "Amharic",
    "bos":          "Bosnian",
    "mya":          "Burmese",
    "kea":          "Cape Verdean Creole",
    "guj":          "Gujarati",
    "hat":          "Haitian Creole",
    "hmn":          "Hmong",             // technically a macro code, maybe hnj is more appropriate in future?
    "khm":          "Khmer (Cambodian)", // khm or kxm (northern) were options
    "lao":          "Lao (Laotian)",
    "npi":          "Nepali",
    "som":          "Somali",
    "tgl":          "Tagalog (Filipino)",
    "tir":          "Tigrinya",
    "lin":          "Lingala",
    "orm":          "Oromo",
    "ksw":          "Karen",
    "eky":          "Karenni", // this is technically Eastern Kayah, and we may need to add Western Kayah (kyu) later to differentiate
    "wol":          "Wolof",
    "kin":          "Kinyarwanda",
    "jam":          "Jamaican Patois",
    "quc":          "K'iche'",
    "mam":          "Mam",
    "tzo":          "Tzotzil Maya",
    "kjb":          "Q'anjob'al/Kanjobal",
    "mon":          "Mongolian",
    "run":          "Kirundi",
    "pan":          "Punjabi", // could also be pnb for western Punjabi
    "que":          "Quechua",
    "knj":          "Akateko",
    "mixt1427":     "Mixteco", // glottolog code
    "kek":          "Q'eqchi",
    "aym":          "Aymara",
    "cak":          "Kaqchikel",
    "ixi":          "Nebaj Ixil",
    "acr":          "Achi",
    "cac":          "Chuj",
    "yua":          "Yucatec",
    "zap":          "Zapoteco", // careful, this is a macrocode for a family of langs
    "poh":          "Poqomchi",
    "poc":          "Poqomam",
    "usp":          "Uspanteko",
    "agu":          "Awakateko/Chalchiteko",
    "nav":          "Navajo",
    "cnh":          "Hakha-Chin",
    "ibo":          "Igbo",
    "ceb":          "Cebuano Visaya",
    "zom":          "Zomi",
    "rhg":          "Rohingya",
    "mal":          "Malayalam",
    "cho":          "Choctaw", // no Boostlingo code, yet?
    "kat":          "Georgian",
    "chk":          "Chuukese",
    "kos":          "Kosraean",
    "pon":          "Pohnpeian",
    "ixj":          "Chajul Ixil",
    "ixl":          "San Juan Cotzal Ixil",
    "hop":          "Hopi",
    "haz":          "Hazaragi",
    "aiq":          "Aimaq",
    "tuk":          "Turkmen",
    "bal":          "Balochi",
    "brh":          "Brahui",
    "sot":          "Sesotho / Sotho",
    "zul":          "Zulu",
    "mar":          "Marathi",
    "kan":          "Kannada",
    "ori":          "Oriya / Odia",
    "asm":          "Assamese",
    "mai":          "Maithili",
    "kun":          "Kunama",
    "yid":          "Yiddish",
    "ugn":          "Ugandan Sign Language",
    "xki":          "Kenyan Sign Language",
    "jac":          "Jakalteko/Poptiʼ",
    "aar":          "Afar",
    "skr":          "Saraiki",
    "hnd":          "Southern Hindko",
    "hno":          "Northern Hindko",
    "arm":          "Armenian",
    "ctu":          "Ch'ol", // Mayan
    "kbp":          "Kabye",
    "kon":          "Kikongo",
    "tzh":          "Tzeltal", // Mayan
    "syl":          "Sylheti",
    "ful":          "Fulani",
    "aka":          "Akan",
    "bam":          "Bambara",
    "tar":          "Central Tarahumara", // Mayan
    "tac":          "Western Tarahumara", // Mayan
    "tzj":          "Tzutujil",           // Mayan
    "anu":          "Anuak",
    "qug":          "Quichua - Chimborazo Highland", // Mayan
    "qxr":          "Quichua - Cañar Highland",      // Mayan
    "qvi":          "Quichua - Imbabura Highland",   // Mayan
    "ahi":          "Tiagba",
    "kro":          "Kru",
    "triq1251":     "Triqui",           // Mayan
    "quz":          "Quechua (Sureño)", // Mayan
    "toj":          "Tojolab'al",       // Mayan
    "csn":          "Colombian Sign Language",
    "quv":          "Sacapulteco", // Mayan
    "snk":          "Soninké",
    "pga":          "South Sudanese Creole Arabic",
    "shu":          "Chadian (Shuwa) Arabic",
    "arq":          "Algerian Arabic (Darja)",
    "apc":          "Lebanese Arabic",
    "gsw":          "Swiss German",
    "nds":          "Low German",
    "gcr":          "French Guianese Creole",
    "psr":          "Portuguese Sign Language",
    "nob":          "Norwegian Bokmål",
    "nno":          "Norwegian Nynorsk",
    "hif":          "Fiji Hindi",
    "psp":          "Filipino Sign Language",
    "hac":          "Gorani/Hawrami",
    "zza":          "Zaza/Zazaki",
    "kmr":          "Northern Kurdish/Kurmanji",
    "sdh":          "Southern Kurdish",
    "hbs":          "Serbo-Croatian",
    "bqn":          "Bulgarian Sign Language",
    "swc":          "Congo Swahili",
    "ghk":          "Geko Karen",
    "blk":          "Pa'o Karen",
    "kvu":          "Yinbaw Karen",
    "kyu":          "Western Kayah",
    "fao":          "Faroese",
    "isl":          "Icelandic",
    "lav":          "Latvian",
    "fas":          "Persian",
    "bak":          "Bashkir",
    "bre":          "Breton",
    "cos":          "Corsican",
    "div":          "Maldivian/Divehi",
    "est":          "Estonian",
    "fry":          "Frisian",
    "kal":          "Greenlandic",
    "iku":          "Inuktitut",
    "gle":          "Irish/Gaeilge",
    "kok":          "Konkani",
    "kir":          "Kyrgyz",
    "dsb":          "Lower Sorbian",
    "mkd":          "Macedonian",
    "mlt":          "Maltese",
    "mri":          "Māori",
    "arn":          "Mapudungun",
    "moh":          "Mohawk",
    "oci":          "Occitan",
    "roh":          "Romansh",
    "smn":          "Sami (Inari)",
    "smj":          "Sami (Lule)",
    "sme":          "Sami (Northern)",
    "sms":          "Sami (Skolt)",
    "sma":          "Sami (Southern)",
    "san":          "Sanskrit",
    "gla":          "Scottish Gaelic",
    "nso":          "Northern Sotho",
    "tsn":          "Setswana",
    "syc":          "Syriac",
    "tgk":          "Tajik",
    "ber":          "Tamazight",
    "hsb":          "Upper Sorbian/Wendish",
    "uig":          "Uyghur",
    "cym":          "Welsh",
    "sah":          "Yakut",
    "iii":          "Yi/Nuosu",
    "bfi":          "British Sign Language (BSL)",
    "isg":          "Irish Sign Language (ISL)",
    "ncs":          "Nicaraguan Sign Language (ISN)",
    "ewe":          "Ewe",
    "gaa":          "Ga",
    "twi":          "Twi (Akan kasa)",
    "kri":          "Sierra Leonean Creole (Krio)",
    "fat":          "Fante (Fanti)",
    "gan":          "Chinese (Gan)",
    "fzho":         "Chinese (Fuzhou)",
    "hak":          "Chinese (Hakka)",
    "hokk1242":     "Chinese (Hokkien)",
    "hsn":          "Chinese (Xiang)",
    "pcm":          "Nigerian Pidgin",
    "smo":          "Samoan",
    "ton":          "Tongan",
    "fij":          "Fijian",
    "tvl":          "Tuvaluan",
    "tpi":          "Tok Pisin",
    "gil":          "Gilbertese/Kiribati",
    "sna":          "Shona",
    "grb":          "Grebo",
    "syr":          "Assyrian/Suret",
    "ban":          "Balinese",
    "bis":          "Bislama",
    "ilo":          "Ilocano",
    "nau":          "Nauru",
    "niu":          "Niuean",
    "pkp":          "Pukapuka",
    "sun":          "Sundanese",
    "tah":          "Tahitian",
    "tkl":          "Tokelauan",
    "pag":          "Pangasinan",
    "nan":          "Chinese (Min Nan)",
    "fcs":          "Quebec Sign Language (LSQ)",
    "lat":          "Latin",
    "hil":          "Hiligaynon/Ilonggo",
    "ace":          "Acehnese",
    "ach":          "Acholi",
    "esu":          "Yup'ik",
    "xho":          "Xhosa",
    "chao1238":     "Chinese (Chaozhou)",
    "ctd":          "Tedim",
    "zyp":          "Zyphe (Zophei)",
    "kdh":          "Cotocoli (Kotokoli, Tem)",
    "din":          "Dinka",
    "dyo":          "Jola-Fonyi",
    "bin":          "Edo",
    "gex":          "Garre",
    "gug":          "Paraguayan Guarani",
    "hain1238":     "Hainanese",
    "har":          "Harari",
    "mey":          "Hassaniya",
    "lom":          "Loma",
    "clt":          "Lautu",
    "ziw":          "Chizigua/Zigula/Mushunguli",
    "mkw":          "Kituba",
    "kik":          "Kikuyu/Gikuyu",
    "jing1262":     "Chinese (Lower Yangtze Mandarin)",
    "jra":          "Jarai",
    "lug":          "Luganda",
    "luo":          "Dholuo",
    "ymm":          "Af Maay",
    "mnk":          "Mandinka",
    "mrh":          "Mara",
    "hlt":          "Matu",
    "myb":          "Mbay",
    "men":          "Mende",
    "ium":          "Iu Mien",
    "hna":          "Mina (Cameroonian)",
    "cnr":          "Montenegrin",
    "nus":          "Nuer",
    "wes":          "Cameroonian Creole",
    "fuc":          "Pulaar",
    "sez":          "Senthang",
    "chen1267":     "Chinese (Sichuanese)",
    "sus":          "Susu",
    "bsq":          "Bassa",
    "cal":          "Carolinian",
    "cha":          "Chamorro",
    "cfm":          "Falam",
    "als":          "Tosk",
    "brx":          "Boro",
    "doi":          "Dogri",
    "kas":          "Kashmiri",
    "mni":          "Meitei",
    "sat":          "Santali",
    "snd":          "Sindhi",
    "tcs":          "Torres Strait Creole/ Yumplatok",
    "ulk":          "Meriam",
    "wim":          "Wik Mungkan",
    "mwp":          "Kalau Lagau Ya",
    "kky":          "Guugu Yimithirr",
    "pis":          "Pijin",
    "wmt":          "Walmajarri",
    "ggd":          "Kukatj",
    "yuul1239":     "Yolŋu Matha",
    "new":          "Newar/Nepal Bhasa",
    "apa":          "Apache",
    "beq":          "Bembe (Kibeembe)",
    "bem":          "Bemba",
    "nya":          "Chewa/Nyanja",
    "sfs":          "South African Sign Language (SASL)",
    "nde":          "Northern Ndebele",
    "ssw":          "Swati",
    "tso":          "Tsonga",
    "ven":          "Venda",
    "toi":          "Tonga (Zambia & Zimbabwe)",
    "tog":          "Tonga (Malawi) (tog)",
    "lua":          "Luba-Kasai",
    "mlg":          "Malagasy",
    "lrl":          "Achomi",
    "mfz":          "Southern Burun/Mabaan",
    "tdt":          "Tetum",
    "ood":          "O'odham",
    "sag":          "Sango",
    "tig":          "Tigre",
    "scn":          "Sicilian",
    "nyn":          "Nkore/Runyankole",
    "kac":          "Jingpho/Kachin",
    "spy":          "Sabaot",
    "kln":          "Nandi",
    "sgc":          "Kipsigis",
    "lan":          "Laru",
    "enb":          "Markweta",
    "pko":          "Pökoot",
    "kpz":          "Kupsabiny",
    "axe":          "Anmatyerre",
    "aly":          "Alyawarr",
    "eth":          "Ethiopian Sign Language",
    "chat1268":     "Chatino",
    "rki":          "Rakhine (Arakanese)",
    "ade":          "Adele",
    "bmb":          "Bembe (Ibembe)",
    "bua":          "Buryat",
    "cre":          "Cree",
    "dgr":          "Dogrib/Tilcho",
    "kqo":          "Eastern Krahn/Konobo",
    "gej":          "Mina-Gen",
    "gom":          "Goan Konkani",
    "pdu":          "Kayan/Padaung",
    "tod":          "Toma",
    "kxf":          "Manumanaw",
    "mls":          "Masalit",
    "dty":          "Dotyali",
    "pau":          "Palauan",
    "pam":          "Kapampangan",
    "pif":          "Pingelapese",
    "krn":          "Sapo/Southern Krahn",
    "kvy":          "Yintale",
    "shn":          "Shan",
    "czt":          "Zotung",
    "blt":          "Tai Dam",
    "bfz":          "Mahasu Pahari",
    "rkm":          "Marka",
    "agq":          "Aghem",
    "emk":          "Eastern Maninkaka",
    "aee":          "Northeastern Pashayi",
    "glh":          "Northwestern Pashayi",
    "psi":          "Southeastern Pashayi",
    "psh":          "Southwestern Pashayi",
    "ibg":          "Ibanag",
    "lir":          "Liberian Kreyol",
    "ssy":          "Saho",
    "mlq":          "Western Malinke",
    "pap":          "Papiamento",
    "tem":          "Temne",
    "krw":          "Western Krahn krw",
    "waci1238":     "Waziristani",
    "arc":          "Aramaic",
    "krj":          "Kinaray-a",
    "haw":          "Hawaiian",
    "raj":          "Rajasthani",
    "bete1265":     "Bété",
    "dzo":          "Dzongkha / Bhutanese",
    "bgc":          "Haryanvi",
    "bho":          "Bhojpuri",
    "mfs":          "Mexican Sign Language (LSM)",
    "bzj":          "Belize Kriol",
    "trf":          "Trinidadian Creole",
    "limo1249":     "Limonese Creole",
    "bjs":          "Bajan",
    "ktb":          "Kambaata",
    "hfy":          "Hadiyya",
    "kab":          "Kabyle",
    "mkj":          "Mokilese",
    "hgm":          "Ngatikese Creole",
    "dag":          "Dagbani",
    "ryu":          "Okinawan",
    "war":          "Waray",
    "csf":          "Cuban Sign Language (LSC)",
    "nzi":          "Nzema",
    "csg":          "Chilean Sign Language (LSCh)",
    "bzs":          "Brazilian Sign Language",
    "wuu":          "Chinese (Wu)",
    "ouji1238":     "Chinese (Wenzhounese)",
    "xiam1236":     "Chinese (Xiamenese)",
    "bhh":          "Bukhori",
    "bai":          "Bamileke",
    "nwe":          "Ngwe",
    "mos":          "Mossi",
    "ssp":          "Spanish Sign Language (LSE)",
    "cbi":          "Cha'palaa/Cayapa",
    "kno":          "Kono",
    "kfr":          "Kutchi",
    "tiv":          "Tiv",
    "byv":          "Medumba",
    "mwr":          "Marwari",
    "kqs":          "Northern Kissi",
    "kss":          "Southern Kissi",
    "gru":          "Soddo",
    "stv":          "Silt'e",
    "zwa":          "Zay",
    "ior":          "Inor",
    "mvz":          "Mesqan",
    "sgw":          "Sebat Bet",
    "phr":          "Pahari-Pothwari",
    "aaa":          "Ghotuo",
    "gkn":          "Gokana",
    "wln":          "Walloon",
    "chim1312":     "Bravanese",
    "ghl":          "Ghulfan",
    "pov":          "Guinea-Bissau Creole",
    "kcm":          "Kara/Gula",
    "guz":          "Gusii",
    "nap":          "Neapolitan",
    "ning1280":     "Chinese (Ningbo)",
    "tsz":          "Purépecha",
    "baju1245":     "Bajuni",
    "lus":          "Mizo",
    "cab":          "Garifuna",
    "tcf":          "Malinaltepec (East)",
    "tpc":          "Azoyú (South)",
    "tpl":          "Tlacoapa (Central)",
    "tpx":          "Acatepec (west)",
    "ttc":          "Tektiteko",
    "nah":          "Nauhatl",
    "amu":          "Northern Amuzgo",
    "azm":          "Amuzgo de Ipalapa",
    "azg":          "Amuzgo de San Pedro",
    "czn":          "Northern Chatino Zenzontepec ",
    "cly":          "Eastern ChatinoTatalpec",
    "cya":          "Eastern Chatino (Lachao - Yolotepec)",
    "dyu":          "Dyula",
    "ymn":          "Maay Maay (Mai-Mai)",
    "fuf":          "Pular",
    "chr":          "Cherokee",
    "kam":          "Kikamba",
    "kxd":          "Brunei Malay",
    "mol":          "Moldovan",
    "dje":          "Zarma/Djerma",
    "keo":          "Kakwa",
    "aks":          "Akaselem (Tchamba)",
    "zsm":          "Malaysian",
    "bod":          "Lhasa Tibetan",
  }
};
